import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { EventAttendee, Task_$reflection, User_$reflection, EventAttendee_$reflection, Event$_$reflection } from "../Shared/SharedModels.jsx";
import { union_type, record_type, class_type, tuple_type, int32_type, array_type, bool_type, option_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { FSharpSet__get_Count, isEmpty, contains as contains_1, toArray, remove, add, empty } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { int32ToString, createObj, numberHash, safeHash, equals, compareArrays } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { append, contains, map } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { startAsPromise } from "../fable_modules/fable-library-js.4.24.0/Async.js";
import { Task, toastServerError, Event$ } from "../ApiClient.jsx";
import { Result_Map } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Array_groupBy } from "../fable_modules/fable-library-js.4.24.0/Seq2.js";
import { successToast, errorToast } from "../Toasts.jsx";
import { createElement } from "react";
import React from "react";
import { useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { SkeletonItem, Skeleton, Caption1, Subtitle2, CardHeader, DataGridCell, DataGridBody, DataGridHeader, DataGridHeaderCell, DataGridRow, DataGrid, Tooltip, Field, Text as Text$, Avatar, createTableColumn as createTableColumn_4, DialogSurface, DialogBody, DialogActions, Checkbox, Body1Strong, DialogContent, DialogTitle, DialogTrigger, Dialog, Persona, Button, Link, Caption2, Badge, Label, tokens, Title3, Card } from "@fluentui/react-components";
import { toArray as toArray_1, tryHead, take, length, empty as empty_1, singleton, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { DocumentArrowDownRegular, SaveRegular, PeopleAudienceRegular, DismissFilled, CheckmarkFilled, PersonDeleteRegular, DismissRegular, WarningFilled, DeleteRegular, LocationRegular, ClipboardTaskListLtrRegular, PeopleQueueRegular, ClockRegular, CalendarDateRegular } from "@fluentui/react-icons";
import { nb } from "date-fns/locale";
import { format as format_2 } from "date-fns";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { unwrap, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useCtx } from "../Context.jsx";
import { Checkbox_toBool } from "../fable_modules/FS.FluentUI.2.5.2/Domain.fs.js";
import { SortDirection } from "../fable_modules/FS.FluentUI.2.5.2/Domain.fs.js";
import { compare } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { compareTo } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { dataGrid_items_Z6D8BD2B8 } from "../fable_modules/FS.FluentUI.2.5.2/Props2.fs.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { notFoundView, unauthorizedView } from "../Helpers.jsx";

class Model extends Record {
    constructor(Event$, IsFetchingEvent, Attendees, IsAuthorized, IsRegistering, TasksToComplete, TasksToRevoke) {
        super();
        this.Event = Event$;
        this.IsFetchingEvent = IsFetchingEvent;
        this.Attendees = Attendees;
        this.IsAuthorized = IsAuthorized;
        this.IsRegistering = IsRegistering;
        this.TasksToComplete = TasksToComplete;
        this.TasksToRevoke = TasksToRevoke;
    }
}

function Model_$reflection() {
    return record_type("Event.EventAttendees.Model", [], Model, () => [["Event", option_type(Event$_$reflection())], ["IsFetchingEvent", bool_type], ["Attendees", array_type(EventAttendee_$reflection())], ["IsAuthorized", bool_type], ["IsRegistering", bool_type], ["TasksToComplete", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [tuple_type(int32_type, User_$reflection())])], ["TasksToRevoke", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [tuple_type(int32_type, User_$reflection())])]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateEvent", "SetIsFetching", "UpdateAttendees", "UpdateIsAuthorized", "UpdateIsRegistering", "CompleteForAttendee", "RevokeFromAttendee", "AttendeeRemoved", "TaskCompletedForUsers", "TaskRevokedForUsers"];
    }
}

function Msg_$reflection() {
    return union_type("Event.EventAttendees.Msg", [], Msg, () => [[["Item", option_type(Event$_$reflection())]], [["Item", bool_type]], [["Item", array_type(EventAttendee_$reflection())]], [["Item", bool_type]], [["Item", bool_type]], [["Item1", EventAttendee_$reflection()], ["Item2", int32_type]], [["Item1", EventAttendee_$reflection()], ["Item2", int32_type]], [["Item", int32_type]], [["Item1", Task_$reflection()], ["Item2", array_type(User_$reflection())]], [["Item1", int32_type], ["Item2", array_type(User_$reflection())]]]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.Event, msg.fields[0], model.Attendees, model.IsAuthorized, model.IsRegistering, model.TasksToComplete, model.TasksToRevoke);
        case 2:
            return new Model(model.Event, model.IsFetchingEvent, msg.fields[0], model.IsAuthorized, model.IsRegistering, model.TasksToComplete, model.TasksToRevoke);
        case 3:
            return new Model(model.Event, model.IsFetchingEvent, model.Attendees, msg.fields[0], model.IsRegistering, model.TasksToComplete, model.TasksToRevoke);
        case 4: {
            const isRegistering = msg.fields[0];
            if (!isRegistering) {
                return new Model(model.Event, model.IsFetchingEvent, model.Attendees, model.IsAuthorized, isRegistering, empty({
                    Compare: compareArrays,
                }), empty({
                    Compare: compareArrays,
                }));
            }
            else {
                return new Model(model.Event, model.IsFetchingEvent, model.Attendees, model.IsAuthorized, isRegistering, model.TasksToComplete, model.TasksToRevoke);
            }
        }
        case 5: {
            const taskIdToComplete = msg.fields[1] | 0;
            const attendee = msg.fields[0];
            return new Model(model.Event, model.IsFetchingEvent, model.Attendees, model.IsAuthorized, model.IsRegistering, attendee.CompletedTasks.some((task) => (task.Id === taskIdToComplete)) ? model.TasksToComplete : add([taskIdToComplete, attendee.User], model.TasksToComplete), remove([taskIdToComplete, attendee.User], model.TasksToRevoke));
        }
        case 6: {
            const taskIdToRevoke = msg.fields[1] | 0;
            const attendee_1 = msg.fields[0];
            const newTasksToRevoke_1 = attendee_1.CompletedTasks.some((task_1) => (task_1.Id === taskIdToRevoke)) ? add([taskIdToRevoke, attendee_1.User], model.TasksToRevoke) : model.TasksToRevoke;
            return new Model(model.Event, model.IsFetchingEvent, model.Attendees, model.IsAuthorized, model.IsRegistering, remove([taskIdToRevoke, attendee_1.User], model.TasksToComplete), newTasksToRevoke_1);
        }
        case 7:
            return new Model(model.Event, model.IsFetchingEvent, model.Attendees.filter((attendee_2) => (attendee_2.User.Id !== msg.fields[0])), model.IsAuthorized, model.IsRegistering, model.TasksToComplete, model.TasksToRevoke);
        case 8:
            return new Model(model.Event, model.IsFetchingEvent, map((attendee_3) => {
                if (contains(attendee_3.User, msg.fields[1], {
                    Equals: equals,
                    GetHashCode: safeHash,
                })) {
                    return new EventAttendee(attendee_3.User, append([msg.fields[0]], attendee_3.CompletedTasks), attendee_3.TimeSignedUp);
                }
                else {
                    return attendee_3;
                }
            }, model.Attendees), model.IsAuthorized, model.IsRegistering, model.TasksToComplete, model.TasksToRevoke);
        case 9:
            return new Model(model.Event, model.IsFetchingEvent, map((attendee_4) => {
                if (contains(attendee_4.User, msg.fields[1], {
                    Equals: equals,
                    GetHashCode: safeHash,
                })) {
                    return new EventAttendee(attendee_4.User, attendee_4.CompletedTasks.filter((task_3) => (task_3.Id !== msg.fields[0])), attendee_4.TimeSignedUp);
                }
                else {
                    return attendee_4;
                }
            }, model.Attendees), model.IsAuthorized, model.IsRegistering, model.TasksToComplete, model.TasksToRevoke);
        default:
            return new Model(msg.fields[0], false, model.Attendees, model.IsAuthorized, model.IsRegistering, model.TasksToComplete, model.TasksToRevoke);
    }
}

function init() {
    return new Model(undefined, true, [], false, false, empty({
        Compare: compareArrays,
    }), empty({
        Compare: compareArrays,
    }));
}

function Promises_fetchEvent(eventId, self, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$.Get(eventId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            dispatch(new Msg(1, [false]));
        }
        else {
            const e = res.fields[0];
            dispatch(new Msg(0, [e]));
            if (e.Teacher.Id === self.Id) {
                dispatch(new Msg(3, [true]));
            }
        }
        return res;
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_fetchAttendees(eventId, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$.GetAttendees(eventId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(2, [res.fields[0]]));
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_completeTasks(tasksToComplete, dispatch, setCtx) {
    let pr_3;
    let pr_2;
    const pr_1 = map((tupledArg) => {
        const users = map((tuple_1) => tuple_1[1], tupledArg[1]);
        const pr = startAsPromise(Task.CompleteCourseTask(tupledArg[0], map((_arg) => _arg.Id, users, Int32Array)));
        return pr.then((res) => Result_Map((task) => {
            let tupledArg_1;
            dispatch((tupledArg_1 = [task, users], new Msg(8, [tupledArg_1[0], tupledArg_1[1]])));
        }, res));
    }, Array_groupBy((tuple) => tuple[0], toArray(tasksToComplete), {
        Equals: (x, y) => (x === y),
        GetHashCode: numberHash,
    }));
    pr_2 = (Promise.all(pr_1));
    pr_3 = (pr_2.then((results) => {
        if (results.some((_arg_1) => {
            if (_arg_1.tag === 0) {
                return false;
            }
            else {
                return true;
            }
        })) {
            errorToast(setCtx, "completeTasksError", "Kunne ikke godkjenne alle oppgaver", "Noe gikk galt med godkjenning av minst én oppgave", undefined);
        }
    }));
    void (pr_3.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_revokeTasks(tasksToRevoke, dispatch, setCtx) {
    let pr_3;
    let pr_2;
    const pr_1 = map((tupledArg) => {
        const taskId = tupledArg[0] | 0;
        const users = map((tuple_1) => tuple_1[1], tupledArg[1]);
        const pr = startAsPromise(Task.RevokeCourseTask(taskId, map((_arg) => _arg.Id, users, Int32Array)));
        return pr.then((res) => Result_Map(() => {
            let tupledArg_1;
            dispatch((tupledArg_1 = [taskId, users], new Msg(9, [tupledArg_1[0], tupledArg_1[1]])));
        }, res));
    }, Array_groupBy((tuple) => tuple[0], toArray(tasksToRevoke), {
        Equals: (x, y) => (x === y),
        GetHashCode: numberHash,
    }));
    pr_2 = (Promise.all(pr_1));
    pr_3 = (pr_2.then((results) => {
        if (results.some((_arg_1) => {
            if (_arg_1.tag === 0) {
                return false;
            }
            else {
                return true;
            }
        })) {
            errorToast(setCtx, "revokeTasksError", "Kunne ikke underkjenne alle oppgaver", "Noe gikk galt med underkjenning av minst én oppgave", undefined);
        }
    }));
    void (pr_3.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_removeAttendee(eventId, userId, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$.RemoveAttendee(eventId, userId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            if (res.fields[0].tag === 2) {
                dispatch(new Msg(7, [userId]));
            }
            else {
                errorToast(setCtx, `removeAttendee${userId}Error`, "Kunne ikke fjerne deltaker", "Noe gikk galt", undefined);
            }
        }
        else {
            dispatch(new Msg(7, [userId]));
            successToast(setCtx, `removeAttendee${userId}Success`, "Deltaker fjernet", "Deltakeren ble fjernet fra kurset");
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function HeaderCard(headerCardInputProps) {
    let elems_12, elems_11, elems_7, elems, el, elems_6, elems_1, el_2, el_4, locale, formatOptions, elems_2, el_6, el_8, locale_1, formatOptions_1, elems_3, el_10, el_12, elems_4, el_14, el_16, elems_5, elems_10, el_30, elems_9, el_28, elems_8, el_26;
    const model = headerCardInputProps.model;
    const event = headerCardInputProps.event;
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const el_32 = Card;
    return createElement(el_32, createObj(ofArray([["style", {
        display: "flex",
        padding: 0,
    }], (elems_12 = [createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton(["display", "flex"]), delay(() => append_1(singleton(["flexGrow", 1]), delay(() => append_1(singleton(["flexWrap", "wrap"]), delay(() => append_1(singleton(["justifyContent", "space-between"]), delay(() => append_1(singleton(["padding", 15]), delay(() => append_1(singleton(["gap", 15 + "px "]), delay(() => {
        const matchValue = screenSize;
        switch (matchValue.tag) {
            case 0:
            case 1:
                return singleton(["justifyContent", "center"]);
            default: {
                return empty_1();
            }
        }
    })))))))))))))))], (elems_11 = [createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => {
        let matchValue_1;
        return append_1((matchValue_1 = screenSize, (matchValue_1.tag === 0) ? (empty_1()) : ((matchValue_1.tag === 1) ? (empty_1()) : singleton(["maxWidth", 60 + "%"]))), delay(() => append_1(singleton(["display", "flex"]), delay(() => append_1(singleton(["gap", 20 + "px "]), delay(() => append_1(singleton(["flexDirection", "column"]), delay(() => singleton(["justifyContent", "space-between"])))))))));
    })))], (elems_7 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 5 + "px ",
    }], (elems = [(el = Title3, createElement(el, {
        children: event.Name,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 20 + "px ",
        flexWrap: "wrap",
    }], (elems_6 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_1 = [(el_2 = CalendarDateRegular, createElement(el_2, {
        fontSize: 24,
        primaryFill: tokens.colorBrandBackground,
    })), (el_4 = Label, createElement(el_4, {
        size: "medium",
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: `${(locale = nb, (formatOptions = {}, (formatOptions.locale = locale, format_2(event.Time, "dd MMMM yyyy", formatOptions))))}`,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_2 = [(el_6 = ClockRegular, createElement(el_6, {
        fontSize: 24,
        primaryFill: tokens.colorBrandBackground,
    })), (el_8 = Label, createElement(el_8, {
        size: "medium",
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: `${(locale_1 = nb, (formatOptions_1 = {}, (formatOptions_1.locale = locale_1, format_2(event.Time, "HH:mm", formatOptions_1))))}`,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_3 = [(el_10 = PeopleQueueRegular, createElement(el_10, {
        fontSize: 24,
        primaryFill: tokens.colorBrandBackground,
    })), (el_12 = Label, createElement(el_12, {
        size: "medium",
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: `${model.Attendees.length}/${event.MaxAttendees}`,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_4 = [(el_14 = ClipboardTaskListLtrRegular, createElement(el_14, {
        fontSize: 24,
        primaryFill: tokens.colorBrandBackground,
    })), (el_16 = Label, createElement(el_16, createObj(toList(delay(() => append_1(singleton(["size", "medium"]), delay(() => append_1(singleton(["style", {
        color: tokens.colorNeutralForeground3,
    }]), delay(() => {
        let matchValue_2, event_1;
        return singleton(["children", `${(matchValue_2 = model.Event, (matchValue_2 != null) ? ((event_1 = matchValue_2, event_1.Course.Tasks.length)) : 0)}`]);
    })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_5 = toList(delay(() => {
        let el_18;
        return append_1(singleton((el_18 = LocationRegular, createElement(el_18, {
            fontSize: 24,
            primaryFill: tokens.colorBrandBackground,
        }))), delay(() => {
            let el_20;
            return append_1(singleton((el_20 = Label, createElement(el_20, {
                size: "medium",
                style: {
                    color: tokens.colorNeutralForeground3,
                },
                children: event.Address,
            }))), delay(() => {
                let el_24, el_22;
                return !event.Enabled ? singleton((el_24 = Badge, createElement(el_24, {
                    style: {
                        marginLeft: 10,
                    },
                    appearance: "tint",
                    color: "warning",
                    size: "large",
                    children: (el_22 = Caption2, createElement(el_22, {
                        children: "Utkast",
                    })),
                }))) : empty_1();
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton(["display", "flex"]), delay(() => append_1(singleton(["flexDirection", "column"]), delay(() => append_1(singleton(["justifyContent", "flex-end"]), delay(() => {
        let matchValue_3;
        return append_1((matchValue_3 = screenSize, (matchValue_3.tag === 0) ? singleton(["flexGrow", 1]) : ((matchValue_3.tag === 1) ? singleton(["flexGrow", 1]) : (empty_1()))), delay(() => append_1(singleton(["gap", 10 + "px "]), delay(() => singleton(["minHeight", 100 + "%"])))));
    })))))))))], (elems_10 = [(el_30 = Link, createElement(el_30, createObj(ofArray([["style", createObj(toList(delay(() => ((screenSize.tag === 0) ? singleton(["alignSelf", "center"]) : ((screenSize.tag === 1) ? singleton(["alignSelf", "center"]) : singleton(["alignSelf", "end"]))))))], ["href", RouterModule_encodeParts(ofArray(["bruker", int32ToString(event.Teacher.Id)]), 1)], (elems_9 = [(el_28 = Button, createElement(el_28, createObj(ofArray([["size", "large"], ["appearance", "subtle"], (elems_8 = [(el_26 = Persona, createElement(el_26, {
        style: {
            justifySelf: "flex-end",
        },
        name: `${event.Teacher.FirstName} ${event.Teacher.LastName}`,
        secondaryText: "Kursholder",
        size: "medium",
        avatar: {
            color: "cranberry",
            image: {
                src: defaultArg(event.Teacher.ImageUrl, ""),
            },
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_8))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_9))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_12))])])));
}

function RemoveAttendeeDialog(removeAttendeeDialogInputProps) {
    let elems_3, el_4, el_2, el, props_43, props_41, el_6, el_14, elems, el_8, el_10, el_12, el_20, elems_1, el_18, el_16, el_26, elems_2, el_24, el_22, name, name_2, elemsToUse;
    const dispatch = removeAttendeeDialogInputProps.dispatch;
    const attendee = removeAttendeeDialogInputProps.attendee;
    const event = removeAttendeeDialogInputProps.event;
    const patternInput = reactApi.useState(false);
    const setIsOpen = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const hasConfirmed = patternInput_1[0];
    const patternInput_2 = useCtx();
    const el_28 = Dialog;
    return createElement(el_28, createObj(ofArray([["open", patternInput[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_3 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = DeleteRegular, createElement(el, {})),
            appearance: "transparent",
        })),
    })), (props_43 = singleton_1((props_41 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Fjern deltaker",
    })), (el_14 = DialogContent, createElement(el_14, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 5 + "px ",
        marginBottom: 10,
    }], (elems = [(el_8 = WarningFilled, createElement(el_8, {
        primaryFill: tokens.colorStatusWarningForeground1,
        fontSize: 48,
    })), (el_10 = Body1Strong, createElement(el_10, {
        style: {
            textAlign: "center",
        },
        children: `Er du sikker på at du vil fjerne ${attendee.User.FirstName} ${attendee.User.LastName} fra dette kurset? Det vil ikke være mulig å angre denne handlingen.`,
    })), (el_12 = Checkbox, createElement(el_12, {
        label: "Ja, jeg er sikker",
        checked: hasConfirmed,
        onChange: (_arg_1, c) => {
            patternInput_1[1](Checkbox_toBool(c));
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])))), (el_20 = DialogActions, createElement(el_20, createObj(ofArray([["position", "start"], (elems_1 = [(el_18 = Button, createElement(el_18, {
        icon: (el_16 = DismissRegular, createElement(el_16, {})),
        children: "Avbryt",
        onClick: (_arg_2) => {
            setIsOpen(false);
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])))), (el_26 = DialogActions, createElement(el_26, createObj(ofArray([["position", "end"], (elems_2 = [(el_24 = Button, createElement(el_24, {
        icon: (el_22 = PersonDeleteRegular, createElement(el_22, {})),
        appearance: "primary",
        children: "Fjern",
        disabled: !hasConfirmed,
        onClick: (_arg_3) => {
            setIsOpen(false);
            Promises_removeAttendee(event.Id, attendee.User.Id, dispatch, patternInput_2[1]);
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_41)),
    })))), (name_2 = DialogSurface, createElement(name_2, {
        children: reactApi.Children.toArray(Array.from(props_43)),
    })))], (elemsToUse = ((length(elems_3) <= 2) ? elems_3 : take(2, elems_3)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function Table(tableInputProps) {
    let tupledArg_2, elems_3, props_27, el_15, name_7, el_21;
    const dispatch = tableInputProps.dispatch;
    const model = tableInputProps.model;
    const event = tableInputProps.event;
    const patternInput = reactApi.useState(["name", new SortDirection(1, [])]);
    const columns = toList(delay(() => {
        let createTableColumn;
        return append_1(singleton((createTableColumn = createTableColumn_4, createTableColumn({
            columnId: "name",
            compare: (delegateArg, delegateArg_1) => {
                const a = delegateArg;
                const b = delegateArg_1;
                return compare(`${a.User.FirstName} ${a.User.LastName}`, `${b.User.FirstName} ${b.User.LastName}`) | 0;
            },
            renderHeaderCell: () => "Deltaker",
            renderCell: (delegateArg_3) => {
                let elems;
                const attendee = delegateArg_3;
                return createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    gap: 5 + "px ",
                    alignItems: "center",
                }], (elems = toList(delay(() => {
                    let el;
                    const name = `${attendee.User.FirstName} ${attendee.User.LastName}`;
                    return append_1(singleton((el = Avatar, createElement(el, {
                        name: name,
                        image: {
                            src: defaultArg(attendee.User.ImageUrl, ""),
                        },
                    }))), delay(() => {
                        let el_2;
                        return singleton((el_2 = Text$, createElement(el_2, {
                            children: name,
                        })));
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
            },
        }))), delay(() => {
            let createTableColumn_1;
            return append_1(singleton((createTableColumn_1 = createTableColumn_4, createTableColumn_1({
                columnId: "signedUp",
                renderHeaderCell: () => "Dato Påmeldt",
                compare: (delegateArg_5, delegateArg_1_1) => compareTo(delegateArg_1_1.TimeSignedUp, delegateArg_5.TimeSignedUp),
                renderCell: (delegateArg_6) => {
                    const locale = nb;
                    const formatOptions = {};
                    formatOptions.locale = locale;
                    return format_2(delegateArg_6.TimeSignedUp, "dd MMM yyyy", formatOptions);
                },
            }))), delay(() => append_1(map((task) => {
                const createTableColumn_2 = createTableColumn_4;
                return createTableColumn_2({
                    columnId: `task-${task.Id}`,
                    renderHeaderCell: () => {
                        const el_4 = Field;
                        return createElement(el_4, {
                            required: task.VerificationRequired,
                            label: `${task.Name}`,
                        });
                    },
                    renderCell: (delegateArg_8) => {
                        const attendee_2 = delegateArg_8;
                        const isCompleted = contains_1([task.Id, attendee_2.User], model.TasksToComplete) ? true : (contains_1([task.Id, attendee_2.User], model.TasksToRevoke) ? false : contains(task, attendee_2.CompletedTasks, {
                            Equals: equals,
                            GetHashCode: safeHash,
                        }));
                        if (model.IsRegistering) {
                            const el_6 = Checkbox;
                            return createElement(el_6, {
                                checked: isCompleted,
                                onChange: (_arg_3, c) => {
                                    let tupledArg, tupledArg_1;
                                    const _b = Checkbox_toBool(c);
                                    if (isCompleted) {
                                        dispatch((tupledArg = [attendee_2, task.Id], new Msg(6, [tupledArg[0], tupledArg[1]])));
                                    }
                                    else {
                                        dispatch((tupledArg_1 = [attendee_2, task.Id], new Msg(5, [tupledArg_1[0], tupledArg_1[1]])));
                                    }
                                },
                            });
                        }
                        else if (isCompleted) {
                            const el_8 = CheckmarkFilled;
                            return createElement(el_8, {
                                primaryFill: tokens.colorStatusSuccessForeground1,
                            });
                        }
                        else {
                            const el_10 = DismissFilled;
                            return createElement(el_10, {
                                primaryFill: tokens.colorStatusDangerForeground1,
                            });
                        }
                    },
                });
            }, event.Course.Tasks), delay(() => {
                let createTableColumn_3;
                return singleton((createTableColumn_3 = createTableColumn_4, createTableColumn_3({
                    columnId: "remove",
                    renderHeaderCell: () => "",
                    renderCell: (delegateArg_10) => {
                        let matchValue, children;
                        const el_13 = Tooltip;
                        return createElement(el_13, createObj(ofArray([["content", "Fjern deltaker"], (matchValue = tryHead([(children = singleton_1(createElement(RemoveAttendeeDialog, {
                            event: event,
                            attendee: delegateArg_10,
                            dispatch: dispatch,
                        })), createElement("div", {
                            children: reactApi.Children.toArray(Array.from(children)),
                        }))]), (matchValue == null) ? ["children", defaultOf()] : ["children", matchValue])])));
                    },
                })));
            }))));
        }));
    }));
    const el_23 = DataGrid;
    return createElement(el_23, createObj(ofArray([dataGrid_items_Z6D8BD2B8(model.Attendees), ["columns", toArray_1(columns)], ["sortable", true], (tupledArg_2 = patternInput[0], ["sortState", {
        sortColumn: unwrap(tupledArg_2[0]),
        sortDirection: tupledArg_2[1],
    }]), ["onSortChange", (delegateArg_11, delegateArg_1_2) => {
        const sortState_1 = delegateArg_1_2;
        patternInput[1]([sortState_1.sortColumn, sortState_1.sortDirection]);
    }], ["getRowId", (delegateArg_12) => delegateArg_12.User.Id], (elems_3 = [(props_27 = singleton_1((el_15 = DataGridRow, createElement(el_15, {
        children: (delegateArg_13, delegateArg_1_3) => {
            const props_22 = singleton_1(delegateArg_13.renderHeaderCell());
            const name_5 = DataGridHeaderCell;
            return createElement(name_5, {
                children: reactApi.Children.toArray(Array.from(props_22)),
            });
        },
    }))), (name_7 = DataGridHeader, createElement(name_7, {
        children: reactApi.Children.toArray(Array.from(props_27)),
    }))), (el_21 = DataGridBody, createElement(el_21, {
        children: (delegateArg_15) => {
            const trd = delegateArg_15;
            const el_19 = DataGridRow;
            return createElement(el_19, {
                key: trd.rowId,
                children: (delegateArg_14, delegateArg_1_4) => {
                    let elems_2;
                    const tcd_1 = delegateArg_14;
                    const el_17 = DataGridCell;
                    return createElement(el_17, createObj(ofArray([["key", tcd_1.columnId], (elems_2 = [tcd_1.renderCell(trd.item)], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])));
                },
            });
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])));
}

function AttendeesCard(attendeesCardInputProps) {
    let elems_4, el_24, el, elems_1, elems_3;
    const dispatch = attendeesCardInputProps.dispatch;
    const model = attendeesCardInputProps.model;
    const event = attendeesCardInputProps.event;
    const setCtx = useCtx()[1];
    const el_26 = Card;
    return createElement(el_26, createObj(ofArray([["size", "large"], (elems_4 = [(el_24 = CardHeader, createElement(el_24, {
        image: (el = PeopleAudienceRegular, createElement(el, {
            fontSize: 32,
        })),
        header: createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
        }], (elems_1 = toList(delay(() => {
            let el_2;
            return append_1(singleton((el_2 = Subtitle2, createElement(el_2, {
                children: "Deltakerliste",
            }))), delay(() => {
                let elems, el_4, el_6;
                return event.Course.Tasks.some((_arg) => _arg.VerificationRequired) ? singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    gap: 5 + "px ",
                }], (elems = [(el_4 = Caption1, createElement(el_4, {
                    style: {
                        color: tokens.colorStatusDangerForeground1,
                    },
                    children: "*",
                })), (el_6 = Caption1, createElement(el_6, {
                    children: "Må godkjennes av kursleder",
                }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty_1();
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))),
        action: createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            minHeight: 50,
        }], (elems_3 = toList(delay(() => {
            let el_10, el_8, elems_2, el_14, el_12, el_18, el_16;
            return !model.IsRegistering ? singleton((el_10 = Button, createElement(el_10, {
                icon: (el_8 = ClipboardTaskListLtrRegular, createElement(el_8, {})),
                children: "Start registrering",
                onClick: (_arg_1) => {
                    dispatch(new Msg(4, [true]));
                },
            }))) : append_1(singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                gap: 5 + "px ",
            }], (elems_2 = [(el_14 = Button, createElement(el_14, {
                icon: (el_12 = DismissRegular, createElement(el_12, {})),
                children: "Avbryt",
                onClick: (_arg_2) => {
                    dispatch(new Msg(4, [false]));
                },
            })), (el_18 = Button, createElement(el_18, {
                icon: (el_16 = SaveRegular, createElement(el_16, {})),
                children: "Lagre",
                appearance: "primary",
                onClick: (_arg_3) => {
                    Promises_completeTasks(model.TasksToComplete, dispatch, setCtx);
                    Promises_revokeTasks(model.TasksToRevoke, dispatch, setCtx);
                    dispatch(new Msg(4, [false]));
                },
            }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                let el_20, el_22;
                return (!isEmpty(model.TasksToComplete) ? true : !isEmpty(model.TasksToRevoke)) ? singleton((el_20 = Caption2, createElement(el_20, {
                    children: `${FSharpSet__get_Count(model.TasksToComplete)} godkjennes og ${FSharpSet__get_Count(model.TasksToRevoke)} underkjennes`,
                }))) : singleton((el_22 = Caption2, createElement(el_22, {
                    children: "",
                })));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))),
    })), createElement(Table, {
        event: event,
        model: model,
        dispatch: dispatch,
    })], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])));
}

export function View(viewInputProps) {
    let elems_3, elems_2, elems_1, el_6, el_8, el_12, el_10, elems, el, el_2;
    const eventId = viewInputProps.eventId;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    let patternInput_1;
    const arg_1 = init();
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    useEffectOnce(() => {
        Promises_fetchEvent(eventId, ctx.User, dispatch, setCtx);
        Promises_fetchAttendees(eventId, dispatch, setCtx);
        if (ctx.User.IsAdmin) {
            dispatch(new Msg(3, [true]));
        }
    });
    const matchValue = model_1.Event;
    if (matchValue != null) {
        const event = matchValue;
        if (!model_1.IsAuthorized) {
            return unauthorizedView();
        }
        else {
            return createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 25 + "px ",
            }], (elems_3 = [createElement("div", createObj(ofArray([["style", {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
            }], (elems_1 = [(el_6 = Title3, createElement(el_6, {
                children: "Deltakere",
            })), (el_8 = Caption1, createElement(el_8, {
                children: "Administrér deltakere og oppgaver",
            }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), (el_12 = Button, createElement(el_12, {
                icon: (el_10 = DocumentArrowDownRegular, createElement(el_10, {})),
                iconPosition: "before",
                children: "Eksportér regneark",
                appearance: "secondary",
                onClick: (_arg_1) => {
                    errorToast(setCtx, "exportNotImplemented", "Ikke implementert", "Eksportering til xlsx er ikke implementert enda", undefined);
                },
            }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement(HeaderCard, {
                event: event,
                model: model_1,
            }), createElement(AttendeesCard, {
                event: event,
                model: model_1,
                dispatch: dispatch,
            })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
        }
    }
    else if (model_1.IsFetchingEvent) {
        const el_4 = Skeleton;
        return createElement(el_4, createObj(ofArray([["style", {
            width: 100 + "%",
            display: "flex",
            flexDirection: "column",
            gap: 25 + "px ",
        }], (elems = [(el = SkeletonItem, createElement(el, {
            style: {
                height: 5 + "vh",
            },
            animation: "wave",
            shape: "rectangle",
        })), (el_2 = SkeletonItem, createElement(el_2, {
            style: {
                height: 40 + "vh",
            },
            animation: "wave",
            shape: "rectangle",
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
    }
    else {
        return notFoundView();
    }
}

//# sourceMappingURL=EventAttendees.jsx.map
